import { useEffect, useState } from "react";

// Chrome/Edge/Android fire `beforeinstallprompt` once, possibly before React mounts, so it is captured globally.
let deferredPrompt = null;
const listeners = new Set();
const notify = () => listeners.forEach((fn) => fn());

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    notify();
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    localStorage.setItem("gag_installed", "1");
    notify();
  });
}

export const isStandalone = () =>
  window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const detectPlatform = () => {
  const ua = navigator.userAgent;
  const ios = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  const iosOtherBrowser = ios && /CriOS|FxiOS|EdgiOS|OPiOS|GSA|Instagram|FBAN|FBAV/.test(ua);
  return { ios, iosSafari: ios && !iosOtherBrowser };
};

export const useInstallPrompt = () => {
  const [, force] = useState(0);
  useEffect(() => {
    const fn = () => force((n) => n + 1);
    listeners.add(fn);
    return () => { listeners.delete(fn); };
  }, []);

  const promptInstall = async () => {
    if (!deferredPrompt) return null;
    const ev = deferredPrompt;
    ev.prompt();
    const { outcome } = await ev.userChoice;
    deferredPrompt = null;
    notify();
    return outcome;
  };

  return { canPrompt: Boolean(deferredPrompt), installed: isStandalone(), promptInstall };
};
